export function convertStaticPriceAmountToMajorUnits(amount: number) {
    const STATIC_CURRENCY_MINOR_UNITS = 100;

    return amount / STATIC_CURRENCY_MINOR_UNITS;
}
